import './style/baseStyle.css';

import React from 'react';
import { render } from 'react-dom';
import { App } from './App/App';

render(<App></App>, document.querySelector('[app-root]'));
